import $ from '@nuskin/nuskinjquery';
import {utilModule} from '../module.js';

utilModule.directive('modalDialog', function() {
    return {
        restrict: 'E',
        scope: {
            show: '=',
            hidex: '='
        },
        transclude: true, // we want to insert custom content inside the directive
        link: function(scope, element, attrs) {
            scope.dialogStyle = {};
            if (attrs.width)
                scope.dialogStyle.width = attrs.width;
            if (attrs.height)
                scope.dialogStyle.height = attrs.height;
            scope.hideModal = function() {
                scope.show = false;
                $('body').removeClass('modal-open');
            };
        },
        template:
            "<div class='ng-modal ng-hide' ng-show='show'>" +
            "   <div class='scrim'></div>" +
            "   <div class='modal'>" +
            "      <i ng-show='!hidex' class='ng-modal-close ns-icon-close' ng-click='hideModal()'></i>" +
            "      <div class='ng-modal-dialog-content' ng-transclude></div>" +
            "   </div>" +
            "</div>"
    };
});
